import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import { getCurrentUser, signOutUser } from "../../api/auth";
import { CurrentUserInterface } from "../../types/User";

interface AuthStateInterface {
  loading: boolean;
  error: boolean;
  errorMsg: string;
  isLoggedIn: boolean;
  currentDomain: string;
  signInAttempted: boolean;
  isLoggedInStatic: boolean;
  data: CurrentUserInterface;
}
const initialState: AuthStateInterface = {
  loading: false,
  error: false,
  errorMsg: "",
  isLoggedIn: false,
  currentDomain: "",
  signInAttempted: false,
  isLoggedInStatic: false,
  data: {
    id: 0,
    name: "",
    email: "",
    role: "",
    title: "",
    type: "",
    profileImageUrl: "",
    account: "",
    accountId: 0,
    roleValue: "",
    privileges: [],
    firstInvite: false,
    createdAt: new Date(),
    active: false,
  },
};

export const tryCurrentUser = createAsyncThunk(
  "auth/current_user",
  async (_, arg: any) => {
    const resp = await getCurrentUser();
    return resp.data;
  }
);

export const SignInUser = createAsyncThunk(
  "auth/sign_in",
  async (_, arg: any) => {}
);

export const SignOutUser = createAsyncThunk(
  "auth/sign_out",
  async (_, arg: any) => {
    const resp = await signOutUser();
    return resp.data;
  }
);

const AuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCurrentDomain(state, { payload }) {
      state.currentDomain = payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(tryCurrentUser.fulfilled, (state, { payload }) => {
      //Setting Role value for the current user

      state.loading = false;
      const { role } = payload;

      state.data = {
        ...payload,
        roleValue: role,
      };
      state.isLoggedIn = true;
    });
    builder.addCase(tryCurrentUser.pending, (state, { payload }) => {
      state.loading = true;
    });
    builder.addCase(tryCurrentUser.rejected, (state, { error }) => {
      state.isLoggedIn = false;
      state.loading = false;
      state.error = true;
      state.errorMsg = error.name + ":" + error.message;
    });
    builder.addCase(SignInUser.fulfilled, (state, { payload }) => {
      state.signInAttempted = true;
      state.loading = false;
      state.isLoggedIn = true;
    });
    builder.addCase(SignInUser.pending, (state, { payload }) => {
      state.signInAttempted = true;
      state.loading = true;
    });
    builder.addCase(SignInUser.rejected, (state, { error }) => {
      state.signInAttempted = true;
      state.loading = false;
      state.error = true;
      state.errorMsg = error.message ? error.message : "";
    });
    builder.addCase(SignOutUser.fulfilled, (state, { payload }) => {
      state.signInAttempted = false;
      state.loading = false;
      state.isLoggedIn = false;
    });
    builder.addCase(SignOutUser.pending, (state, { payload }) => {
      state.loading = true;
    });
    builder.addCase(SignOutUser.rejected, (state, { error }) => {
      state.loading = false;
      state.error = true;
      state.errorMsg = error.message ? error.message : "";
    });
  },
});

export default AuthSlice.reducer;
